export default __webpack_public_path__ + "static/n910_mobile_android_pos-abc5c4e4d4e3462748b69177b9806630.png";